﻿import * as React from "react";
import { useApiService } from "../hooks";
import { SystemApi } from "../api";
import { usePrevious } from "nsitools-react";
import { useRequest } from "ahooks";
import { useLocation } from "react-router";
import { useGlobalData, useSearchCriteriaContext } from "../contexts";

export function useAutoCheckVersionRefresh() {
  const systemApi = useApiService(SystemApi);
  const { pathname } = useLocation();
  var globalData = useGlobalData();
  const { clearCriterias } = useSearchCriteriaContext();
  const [mustRefreshFrontend, setMustRefreshFrontend] = React.useState(false);
  const { data: systemInfo } = useRequest(() => systemApi.get(), {
    pollingInterval: 60000,
  });

  const previousPathName = usePrevious(pathname);
  const previousVersion = usePrevious(systemInfo);
  React.useEffect(() => {
    if (mustRefreshFrontend && previousPathName !== pathname) {
      console.log("Force refresh frontend and clear search cache, version changed !");
      clearCriterias();
      window.location.reload();
    }
  }, [clearCriterias, mustRefreshFrontend, pathname, previousPathName]);

  React.useEffect(() => {
    if (previousVersion && previousVersion?.applicationVersion !== systemInfo?.applicationVersion) {
      console.log("Backend version has changed, SRSH application will be refreshed soon...");
      setMustRefreshFrontend(true);
    }
  }, [previousVersion, systemInfo?.applicationVersion]);
}
